<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{
              $t(`paramInterneAdmin.gestionInterface.message.form.${message.id ? 'edit' : 'add'}`)
            }}
          </h1>
        </div>
      </div>
    </div>
    <div class="pd-4">
      <error-msg-component
            :messages="messagesErreur"
            :error="error"
            :messagesChampsVide="messagesChampsVide"
            :champsVide="champsVide"
            :title="'ajoutDevis.problemOccurred'"
            :withEmplyFields="true"
            @close="error = false"/>
    </div>
    <div class="card-content">
        <div class="columns is-multiline">
            <b-field
                class="column is-6 obligatoire"
                :label="$t('paramInterneAdmin.gestionInterface.message.form.dateDebutAffichage')">
                <b-datepicker
                    v-model="message.dateDebutAffichage"
                    :max-date="message.dateFinAffichage"
                    icon="calendar-today"
                    nearby-selectable-month-days
                    show-week-number
                    editable>
                </b-datepicker>
            </b-field>
            <b-field
                class="column is-6"
                :label="$t('paramInterneAdmin.gestionInterface.message.form.dateFinAffichage')">
                <b-datepicker
                    v-model="message.dateFinAffichage"
                    :min-date="message.dateDebutAffichage"
                    icon="calendar-today"
                    nearby-selectable-month-days
                    show-week-number
                    editable>
                </b-datepicker>
            </b-field>
            <qd-checkbox
                class="column is-12"
                v-model="message.visibleUniquement"
                :disabled="message.id">
                {{ $t('paramInterneAdmin.gestionInterface.message.form.visibleUniquement')}}
            </qd-checkbox>
            <b-field
                class="column is-12 obligatoire"
                :label="$t('paramInterneAdmin.gestionInterface.message.form.message')">
              <qd-text-editor v-model="message.message" />
            </b-field>
        </div>
      <footer class="is-flex">
        <button class="button boutonAction" @click="$parent.close()">
          {{ $t('general.button.cancel')}}
        </button>
        <button
          class="button boutonAction is-addOrEdit"
          @click="save()">
          {{ $t('general.button.sauvegarder') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import formatIsoDate from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import { create, update } from '@/api/messageAcceuil';
import messageSucces from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/validation/validation';
import translate from '@/services/parametrage/translator/translatorMessageAcceuil';

export default {
  data() {
    return {
      canRender: false,
      error: false,
      messagesErreur: [],
      champsVide: [],
      messagesChampsVide: [],
    };
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    async save() {
      if (this.message.id) {
        await this.update();
        return;
      }
      await this.create();
    },
    async update() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreur = [];
        this.error = false;
        this.messagesChampsVide = [];
        this.champsVide = [];
        const messageToUpdate = cloneDeep(this.message);
        messageToUpdate.dateDebutAffichage = formatIsoDate(messageToUpdate.dateDebutAffichage);
        messageToUpdate.dateFinAffichage = formatIsoDate(messageToUpdate.dateFinAffichage);
        await update(messageToUpdate);
        messageSucces(this.$t('paramInterneAdmin.gestionInterface.message.updateSuccess'));
        this.$emit('recherche');
        this.$parent.close();
      } catch (e) {
        this.error = true;
        if (e.response.data.error) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messagesErreur, this.messagesChampsVide, translate);
          return;
        }
        messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
    async create() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreur = [];
        this.error = false;
        this.messagesChampsVide = [];
        this.champsVide = [];
        const messageToCreate = cloneDeep(this.message);
        messageToCreate.dateDebutAffichage = formatIsoDate(messageToCreate.dateDebutAffichage);
        messageToCreate.dateFinAffichage = formatIsoDate(messageToCreate.dateFinAffichage);
        await create(messageToCreate);
        messageSucces(this.$t('paramInterneAdmin.gestionInterface.message.createSuccess'));
        this.$emit('recherche');
        this.$parent.close();
      } catch (e) {
        this.error = true;
        if (e.response.data.error) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messagesErreur, this.messagesChampsVide, translate);
          return;
        }
        messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>

<style>

</style>
